import { useSnapshot } from "valtio";
import FolderTree from "./FolderTree";
import TagGroupSection from "./TagGroupSection";
import { contentCatalogStore } from "../contentCatalogStore";
import { useCallback } from "react";
import type { AdMenuItemsFn, FolderMenuItemsFn } from "../contentCatalog";
import type { Ad } from "@models/Ad.model";

interface LeftPanelProps {
    adMenuItems?: AdMenuItemsFn;
    folderMenuItems?: FolderMenuItemsFn;
    collectionMenuItems?: FolderMenuItemsFn;
    collectionAdMenuItems?: AdMenuItemsFn;
    onAdClick?: (ad: Ad) => void;
    onCreateRootFolder?: () => void;
    onCreateRootCollection?: () => void;
    enableDnd?: boolean;
}

export default function LeftPanel({
    adMenuItems,
    folderMenuItems,
    collectionMenuItems,
    collectionAdMenuItems,
    onAdClick,
    onCreateRootFolder,
    onCreateRootCollection,
    enableDnd,
}: LeftPanelProps) {
    const { panelMode, selectedTagIds } = useSnapshot(contentCatalogStore)

    const clearAll = useCallback(() => contentCatalogStore.selectedTagIds = [], [])

    return (
        <aside className="left-panel">
            <div className="left-panel-header">
                <span className="left-panel-title">{panelMode === "filter" ? "Filters" : "Browse"}</span>
                {panelMode === "filter" && selectedTagIds.length > 0 && (
                    <button className="filter-clear-all" onClick={clearAll}>
                        Clear all ({selectedTagIds.length})
                    </button>
                )}
            </div>
            <div className="left-panel-body">
                {panelMode === "browse"
                    ? <FolderTree
                        adMenuItems={adMenuItems}
                        folderMenuItems={folderMenuItems}
                        collectionMenuItems={collectionMenuItems}
                        collectionAdMenuItems={collectionAdMenuItems}
                        onAdClick={onAdClick}
                        onCreateRootFolder={onCreateRootFolder}
                        onCreateRootCollection={onCreateRootCollection}
                        enableDnd={enableDnd}
                    />
                    : contentCatalogStore.tagGroups.map((g) => (
                        <TagGroupSection key={g.id} group={g} />
                    ))}
            </div>
        </aside>
    );
}
